/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const RateGenerationRequestRatingEnum = {
    disliked: 'disliked',
    liked: 'liked'
};
/**
 * Check if a given object implements the RateGenerationRequest interface.
 */
export function instanceOfRateGenerationRequest(value) {
    if (!('rating' in value) || value['rating'] === undefined)
        return false;
    return true;
}
export function RateGenerationRequestFromJSON(json) {
    return RateGenerationRequestFromJSONTyped(json, false);
}
export function RateGenerationRequestFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'rating': json['rating'],
    };
}
export function RateGenerationRequestToJSON(json) {
    return RateGenerationRequestToJSONTyped(json, false);
}
export function RateGenerationRequestToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'rating': value['rating'],
    };
}
